module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"\r\n    viewBox=\"0 0 36 36\">\r\n  <path d=\"M18,21.32a1.3,1.3,0,0,0,1.3-1.3V14a1.3,1.3,0,1,0-2.6,0v6A1.3,1.3,0,0,0,18,21.32Z\"></path>\r\n  <circle cx=\"17.95\" cy=\"24.27\" r=\"1.5\"></circle>\r\n  <path d=\"M30.33,25.54,20.59,7.6a3,3,0,0,0-5.27,0L5.57,25.54A3,3,0,0,0,8.21,30H27.69a3,3,0,0,0,2.64-4.43Zm-1.78,1.94a1,1,0,0,1-.86.49H8.21a1,1,0,0,1-.88-1.48L17.07,8.55a1,1,0,0,1,1.76,0l9.74,17.94A1,1,0,0,1,28.55,27.48Z\"></path>\r\n</svg>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/kendu/ui/components/kd-alert/icons/warning.html
// module id = 291
// module chunks = 0